import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=a7a0a818"
import script from "./Areas.vue?vue&type=script&lang=js"
export * from "./Areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a0a818')) {
      api.createRecord('a7a0a818', component.options)
    } else {
      api.reload('a7a0a818', component.options)
    }
    module.hot.accept("./Areas.vue?vue&type=template&id=a7a0a818", function () {
      api.rerender('a7a0a818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/usuario/Areas.vue"
export default component.exports